// MIT License. See license.txt

// provide a namespace
if (!window.platia_tech) window.platia_tech = {};

platia_tech.provide = function (namespace) {
	// docs: create a namespace //
	var nsl = namespace.split(".");
	var parent = window;
	for (var i = 0; i < nsl.length; i++) {
		var n = nsl[i];
		if (!parent[n]) {
			parent[n] = {};
		}
		parent = parent[n];
	}
	return parent;
};

platia_tech.provide("locals");
platia_tech.provide("platia_tech.flags");
platia_tech.provide("platia_tech.settings");
platia_tech.provide("platia_tech.utils");
platia_tech.provide("platia_tech.ui.form");
platia_tech.provide("platia_tech.modules");
platia_tech.provide("platia_tech.templates");
platia_tech.provide("platia_tech.test_data");
platia_tech.provide("platia_tech.utils");
platia_tech.provide("platia_tech.model");
platia_tech.provide("platia_tech.user");
platia_tech.provide("platia_tech.session");
platia_tech.provide("platia_tech._messages");
platia_tech.provide("locals.DocType");

// for listviews
platia_tech.provide("platia_tech.listview_settings");
platia_tech.provide("platia_tech.tour");
platia_tech.provide("platia_tech.listview_parent_route");

// constants
window.NEWLINE = "\n";
window.TAB = 9;
window.UP_ARROW = 38;
window.DOWN_ARROW = 40;

// proxy for user globals defined in desk.js

// API globals
window.cur_frm = null;
